<template>
  <div class="mt-2">
    <button 
      :type="type" 
      :class="buttonClasses" 
      :disabled="loading || disabled"
      class="relative"
    >
      <span v-if="loading" class="flex items-center justify-center">
        <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ loadingLabel || 'Processing...' }}
      </span>
      <span v-else>{{ label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'submit'
    },
    label: String,
    loading: {
      type: Boolean,
      default: false
    },
    loadingLabel: {
      type: String,
      default: 'Processing...'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    loading(newVal) {
      console.log('=== BUTTON COMPONENT ===');
      console.log('Loading prop changed to:', newVal);
      console.log('Current label:', this.label);
      console.log('Loading label:', this.loadingLabel);
    }
  },
  mounted() {
    console.log('Button mounted with initial loading state:', this.loading);
  },
  computed: {
    buttonClasses() {
      const baseClasses = 'font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-200';
      const enabledClasses = 'text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800';
      const disabledClasses = 'text-white bg-gray-400 cursor-not-allowed dark:bg-gray-600';
      
      if (this.loading || this.disabled) {
        return `${baseClasses} ${disabledClasses}`;
      }
      
      return `${baseClasses} ${enabledClasses}`;
    }
  }
};
</script>
